import {
  GAME_ID_FROM_URL,
  ANDAR_BAHAR_ID,
  ANDAR_BAHAR_OTT_ID,
  ANDAR_BAHAR_ULTIMATE_ID,
} from '@ezugi/constants/src/gameIds';

import {
  PAYOUT_DEFAULT_FORMAT,
  PAYOUT_DEFAULT_SEPARATOR,
  PAYOUT_FRACTION_FORMAT,
  PAYOUT_FRACTION_SEPARATOR,
  PAYOUT_MULTIPLIER_FORMAT,
  PAYOUT_MULTIPLIER_SEPARATOR,
} from '../constants/payouts';

/**
 *
 * Returns a number with the specified number of digits after the separator
 * without rounding the value as the default toFixed does
 *
 * @param {Number} value
 * @param {Number} numberOfDigits
 * @returns {Number}
 */
const toFixed = (value: number, numberOfDigits = 2) => {
  if (Number.isInteger(value)) return value;

  let valueString = value.toString();
  const decimalSeparator = valueString.includes(',') ? ',' : '.';

  valueString = valueString.slice(0, (valueString.indexOf(decimalSeparator)) + numberOfDigits + 1);

  return Number(valueString);
};

export const isABonURL = GAME_ID_FROM_URL === ANDAR_BAHAR_ID;
export const isOTTABonURL = GAME_ID_FROM_URL === ANDAR_BAHAR_OTT_ID;
export const isUABonURL = GAME_ID_FROM_URL === ANDAR_BAHAR_ULTIMATE_ID;

// safari doesn't support lookbehind to omit `https?`, so we need to do this instead
export const sanitizeUrl = (url: string) => url
  .split(/(https?:\/\/)/)
  .map((part) => (part.match(/https?:\/\//) ? part : part.replace(/\/{2,}/g, '/')))
  .join('');

export const formatPayout = (payout: string, multiplier = 1, format = PAYOUT_DEFAULT_FORMAT) => {
  switch (format) {
  case PAYOUT_FRACTION_FORMAT: {
    const payoutArr = payout.split(PAYOUT_FRACTION_SEPARATOR);
    const payoutValue = parseFloat(payoutArr[0]) || 1;

    return `${toFixed(payoutValue * multiplier)}${PAYOUT_FRACTION_SEPARATOR}${payoutArr[1]}`;
  }
  case PAYOUT_MULTIPLIER_FORMAT: {
    const payoutArr = payout.split(PAYOUT_MULTIPLIER_SEPARATOR);
    const payoutValue = parseFloat(payoutArr[1]) || 1;

    return `${PAYOUT_MULTIPLIER_SEPARATOR}${toFixed(payoutValue * multiplier)}`;
  }
  default: {
    const payoutArr = payout.split(PAYOUT_DEFAULT_SEPARATOR);
    const payoutValue = parseFloat(payoutArr[0]) || 1;

    return `${toFixed(payoutValue * multiplier)}${PAYOUT_DEFAULT_SEPARATOR}${payoutArr[1]}`;
  }
  }
};
